import DotNetObject = DotNet.DotNetObject;
import { PermissionSystemGroup } from '@crimsontide/core/client/interfaces';

export const PermissionSystemGroupService = (() => {
  let dotNetObj: DotNetObject;
  let cachedPermissionSystemGroups: PermissionSystemGroup[];

  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const getPermissionSystemGroups = async (useCache: boolean = true): Promise<PermissionSystemGroup[]> => {
    if (useCache && cachedPermissionSystemGroups != null)
      return cachedPermissionSystemGroups;

    if (dotNetObj) {
      cachedPermissionSystemGroups = await dotNetObj.invokeMethodAsync<PermissionSystemGroup[]>('GetPermissionSystemGroupsAsync');
      return cachedPermissionSystemGroups;
    } else {
      throw 'PermissionSystemGroupService DotNet Object Reference has not yet been implemented';
    }
  };

  return {
    setDotNetReference,
    getPermissionSystemGroups,
  };
})();
